<template>
  <vx-card
    id="app_body"
    class="flex-1 flex-col w-full relative overflow-x-hidden"
  >
    <template slot="no-body">
      <global-header :buttonBack="true" :actions="false"></global-header>
      <div class="w-full p-5 pt-0">
        <vs-alert
          v-if="!$apollo.queries.surat.loading && surat"
          color="primary"
          :title="`Berdasarkan ${surat.tipe == 'surat_keluar' ? 'Surat Keluar' : 'Surat Masuk'}`"
          active="true"
          @click="handleClickSurat"
          class="mb-5 cursor-pointer"
        >
          {{ surat.index }}
        </vs-alert>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="" class="flex mb-1">Judul Agenda :</label>
            <vs-input
              class="w-full"
              placeholder="Ketik Judul Agenda"
              v-model="input.judul"
            />
          </div>
        </div>

        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="" class="flex mb-1">Deskripsi :</label>
            <global-quill-editor
              class="w-full"
              v-model="input.deskripsi"
            ></global-quill-editor>
          </div>
        </div>

        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="" class="flex mb-1">Lokasi Agenda : </label>
            <vs-input
              class="w-full"
              placeholder="Ketik Lokasi Agenda"
              v-model="input.lokasi"
            />
          </div>
        </div>

        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="" class="mb-1 flex">Kategori Agenda : </label>
            <vs-select
              :options="kategoriAgenda"
              class="w-full"
              placeholder="Pilih Kategori"
              v-model="input_kategori_agenda"
              label="nama"
              :reduce="kategori => kategori.id"
            />
          </div>
        </div>
        <h3 class="">Tanggal dan Jam</h3>
        <vs-divider></vs-divider>
        <div class="vx-row mb-5 flex flex-col md:flex-row md:items-center">
          <div class="vx-col mb-3">
            <flat-pickr
              :config="configdateTimePicker"
              v-model="input.waktu_mulai"
              class="w-full"
              placeholder="Pilih Tanggal Mulai"
            />
          </div>
          <div class="vx-col mb-3" v-if="!sampai_selesai">
            <flat-pickr
              :config="configdateTimePicker"
              class="w-full"
              v-model="input.waktu_selesai"
              placeholder="Pilik Tanggal Selesai"
            />
          </div>
          <div class="vx-col mb-3">
            <vs-checkbox v-model="sampai_selesai">Sampai Selesai</vs-checkbox>
          </div>
        </div>
        <h3 class="">Peserta</h3>
        <vs-divider></vs-divider>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="" class="mb-1 flex">Peserta :</label>
            <global-quill-editor
              class="w-full"
              label="Peserta Agenda"
              v-model="input.peserta"
            ></global-quill-editor>
            <br>
            <vs-checkbox v-model="semua_pegawai">Semua Pegawai</vs-checkbox>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="" class="mb-1 flex">Undang Pegawai:</label>
            <vs-select
              :options="listPeserta"
              multiple
              class="w-full"
              placeholder="Pilih Pegawai"
              v-model="input_peserta_agenda"
              label="nama"
              :disabled="semua_pegawai"
              :reduce="peserta => peserta.id"
            />
            <small class="text-grey"
              >* Undang pegawai yang mempunyai akun digof</small
            >
          </div>
        </div>

        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-button @click="submit()">Simpan Agenda</vs-button>
          </div>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import { ALL } from "@/query/pengguna";
import { GET_BY_UUID } from "@/query/surat";
import { CREATE } from "@/query/agenda";
import { GET_ALL } from "@/query/kategori-agenda.js";
import { store as storeNotification } from "@/firebase/notification";
import moment from "moment";

export default {
  name: "AgendaCreate",
  components: {
    "vs-select": vSelect,
    flatPickr
  },
  data() {
    return {
      input: {
        judul: null,
        lokasi: null,
        deskripsi: null,
        waktu_mulai: null,
        waktu_selesai: null,
        pengguna_id: this.$sanctum.getUser().id,
        peserta: null
      },
      input_peserta_agenda: [],
      input_kategori_agenda: [],
      sampai_selesai: true,
      semua_pegawai: false,
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "Y-m-d H:i:S",
        time_24hr: true
      }
    };
  },
  computed: {
    tipeSurat() {
      if (this.surat)
        return this.surat.tipe === "surat_keluar" ? "Keluar" : "Masuk";
      else return "";
    },
    peserta_agenda: function() {
      return this.input_peserta_agenda.map(data => ({ pengguna_id: data }));
    }
  },
  apollo: {
    listPeserta: {
      query: ALL,
      update: data => data.pengguna.data,
      variables() {
        return {
          // assume show all data in pagination
          perPage: 10000
        };
      }
    },
    kategoriAgenda: {
      query: GET_ALL,
      update: data => data.kategoriAgenda.data,
      variables() {
        return {
          perPage: 100000
        };
      }
    },
    surat: {
      query: GET_BY_UUID,
      update: data => data.surat,
      skip: true,
      variables() {
        return {
          uuid: this.$route.query.surat
        };
      }
    }
  },
  watch: {
    sampai_selesai() {
      if (this.waktu_selesai) this.input.waktu_selesai = null;
    },
    surat(val) {
      if (val !== null) this.input.surat_id = val.id;
    },
    semua_pegawai() {
      if(this.semua_pegawai){
        this.input.peserta = 'Semua pegawai';
        this.listPeserta.map(item => {
          this.input_peserta_agenda.push(item.id);
        });
      }
      else{
        this.input.peserta = null;
        this.input_peserta_agenda = [];
      }
    }
  },
  created() {
    this.$store.dispatch("globalApp/setHeaderTitle", "Buat Agenda");
    this.fetchSurat();
  },
  methods: {
    async submit() {
      this.$vs.loading();
      await this.$apollo
        .mutate({
          mutation: CREATE,
          variables: {
            input: {
              ...this.input,
              kategori_agenda_id: this.input_kategori_agenda,
              peserta_agenda: {
                create: [...this.peserta_agenda]
              }
            }
          }
        })
        .then(data => {
          const agendaUuid = data.data.agendaCreate.uuid;
          const agendaId = data.data.agendaCreate.id;
          this.$router.push({
            name: "agenda-detail",
            params: { uuid: agendaUuid }
          });
          this.sendNotification(agendaId, agendaUuid);
        })
        .catch(error => {
          console.error(error);
          this.$vs.notify({
            color: "danger",
            title: "Terjadi Kesalagan",
            text: "Periksa data anda"
          });
        });
      this.$vs.loading.close();
    },
    fetchSurat() {
      if (this.$route.query.surat) this.$apollo.queries.surat.skip = false;
    },
    handleClickSurat() {
      this.$router.push({
        name: this.surat.tipe == 'surat_keluar' ?  'surat-keluar-detail' : 'surat-masuk-detail',
        params: { uuid: this.surat.uuid }
      });
    },
    sendNotification(id, uuid){
      let agendaTime = `tanggal ${moment(this.input.waktu_mulai).format("DD MMM YYYY")} pukul ${moment(this.input.waktu_mulai).format("HH:mm")}`
      let penggunaList = [];
      this.peserta_agenda.map((item) => {
        penggunaList.push(item.pengguna_id);
      });

      let data = {
        except_login_id : this.$sanctum.getUser().login_id,
        pengguna_id : null,
        pengguna_list : penggunaList,
        judul : 'Notifikasi Agenda',
        konten : `Anda mendapatkan agenda ${this.input.judul} pada tanggal ${agendaTime}` ,
        halaman : 'agenda-detail',
        notifikasiable_id : id,
        notifikasiable_uuid : uuid,
        ikon : 'CalendarIcon'
      }
      storeNotification(data);
    }
  }
};
</script>
